(() => {
    'use strict';

    angular
        .module('uwAgenda.users')
        .controller('UsersOverviewController', [
            '$state',
            '$stateParams',
            'SharedAgendaService',
            'UserSearchPaginationService',
            'DownloadService',
            'ExportFormat',
            'EmailService',
            'rolesForUser',
            'grouppractices',
            'UserFilterService',
            'Email',
            'ItemsPerPage',
            'UserService',
            'BackgroundJobState',
            'HelperService',
            UsersOverviewControllerFn]);

    function UsersOverviewControllerFn(
        $state,
        $stateParams,
        SharedAgendaService,
        UserSearchPaginationService,
        DownloadService,
        ExportFormat,
        EmailService,
        rolesForUser,
        grouppractices,
        UserFilterService,
        Email,
        ItemsPerPage,
        UserService,
        BackgroundJobState,
        HelperService) {
        let vm = this;

        vm.rolesForUser = [];
        vm.groupPractices = [];
        vm.userCardColumns = 0;
        vm.overview = null;

        vm.hasSharedAgendas =
            SharedAgendaService.data.agendas && 
            SharedAgendaService.data.agendas.length > 1;
        
        vm.isSpecialAgenda = SharedAgendaService.currentPracticeIsRingphoneHq() || SharedAgendaService.currentAgendaIsSuperAdmin();
        vm.hasIntegration = SharedAgendaService.currentUserHasIntegrationWithSynchronization();
        vm.isPartOfIntegration = SharedAgendaService.currentUserIsPartOfIntegrationWithSynchronization();
        vm.mergeState = SharedAgendaService.currentUserIntegrationMergeState();
        vm.backgroundJobState = BackgroundJobState;
        vm.showMergeState =
            vm.isPartOfIntegration && (
                vm.mergeState !== BackgroundJobState.None.value &&
                vm.mergeState !== BackgroundJobState.Finished.value &&
                vm.mergeState !== BackgroundJobState.Failed.value);

        vm.showMergeButton =
            vm.isPartOfIntegration && (
                vm.mergeState === BackgroundJobState.None.value ||
                vm.mergeState === BackgroundJobState.Finished.value ||
                vm.mergeState === BackgroundJobState.Failed.value);
        
        vm.showErrorMergeState =
            vm.isPartOfIntegration &&
            vm.mergeState === BackgroundJobState.Failed.value;

        vm.new = function () {
            $state.go('Home.UserDetail.Profile');
        };

        vm.email = function () {
            var email = new Email();
            var currentUserEmail = SharedAgendaService.currentUser().mainEmail;
            if (currentUserEmail) {
                email.addMailContactInfo(currentUserEmail);
            }
            // add list of user to contact-infos
            vm.overview.data.results.forEach(function (item) {
                if (item && item.contactInfos && 
                    item.contactInfos.filter(c => c.userContactInfoType.id === 3)[0]) {
                    var contactEmail = item.contactInfos.filter(c => c.userContactInfoType.id === 3)[0].value;
                    if (contactEmail) {
                        email.addMailContactInfoBCC(contactEmail);
                    } 
                }
            });

            EmailService.write(email);
        };

        vm.export = function () {
            if (vm.overview.data.results.length > 0) {
                DownloadService.exportFilteredContacts(SharedAgendaService.currentUser().id, UserSearchPaginationService.data.active, UserSearchPaginationService.data.blocked, UserSearchPaginationService.data.deleted, UserSearchPaginationService.data.pagination).then(function (response) {
                    DownloadService.openReport(ExportFormat.CSV.value, response, "user");
                });
            }
        };
        
        vm.merge = () => {
            UserService.showCleanupContactsById(SharedAgendaService.currentUser().id);
        };
        
        vm.showSyncInfo = () => {
            HelperService.showInfoModal(
                'sync_info_header',
                'sync_info');
        };

        activate();

        function activate() {
            SharedAgendaService.allow();
            vm.rolesForUser = rolesForUser;
            vm.groupPractices = grouppractices;
            //set default number of user card columns, will be updated on window size change in usercard-resize directive
            vm.userCardColumns = 4;
            vm.overview = UserSearchPaginationService;
            vm.overview.data.pagination.itemsPerPage = ItemsPerPage.UserCards.value;
            UserFilterService.data.captionFilter = null;
        }
    }
})();
